// 数据文件 URL 解析：把「站点内逻辑路径」映射到「外部存储地址」。
//
// 背景：public/data 下有 43MB 静态数据。只要它随每次构建进部署包，就会直接计入
// Vercel Deployment Storage（$0.10/GB·月，按产物**原始体积**计费，传输时的 gzip
// 不算数）。P1 把这批文件外置到 Cloudflare R2，构建产物里不再有 /data。
//
// 设计取舍：用**单一 base**，而不是「逐文件 manifest」。
//   早先的 manifest 方案必须在构建时 import，于是「数据更新」必然等价于「重新部署」——
//   这与目标直接冲突。而 index.json 里的 file 字段本来就是相对路径、文件名自带日期
//   （新数据 = 新文件名），所以运行时只拼一个 base 就够：上传数据不再触发部署。
//
// 回退/灰度：VUE_APP_DATA_BASE 为空时**原样返回入参**，行为与迁移前完全一致 ——
// 本地 dev 默认走这条路径，/data/* 由 devServer 从磁盘直接提供（见 vue.config.js）。

// 构建时由 webpack DefinePlugin 内联（Vue CLI 只暴露 VUE_APP_* 前缀的变量）。
// 取值形如 "https://img.photoscope.cc/aiproduct"，末尾斜杠统一剥掉。
const DATA_BASE = String(process.env.VUE_APP_DATA_BASE || '').replace(/\/+$/, '');

// 带协议的绝对 URL（http://、https://、r2:// 等）直接放行
const ABSOLUTE_URL = /^[a-z][a-z0-9+.-]*:\/\//i;

// 取路径最后一段作为对象键。R2 上是**扁平存放**的（键 = 文件名），
// 所以逻辑路径的目录部分在这里被丢弃：
//   "data/2026_09-07_09-13.json" -> "2026_09-07_09-13.json"
//   "/data/tools.json"           -> "tools.json"
// 同时剥离 query/hash，避免调用方忘记规范化。
export function dataFileKey(file) {
  return String(file)
    .split(/[?#]/)[0]
    .split('/')
    .filter(Boolean)
    .pop() || '';
}

// 逻辑路径 -> 实际可 fetch 的 URL。
// base 为空（未配置外置）时原样返回，保证本地 dev 与迁移前行为一致。
// base 参数仅用于测试注入，生产调用不要传。
export function resolveDataUrl(file, base = DATA_BASE) {
  if (!file) return file;
  const raw = String(file);
  if (ABSOLUTE_URL.test(raw)) return raw;
  // 入口再归一化一次末尾斜杠：base 也可能由调用方传入（如注入的配置），
  // 不能只依赖模块加载时对 DATA_BASE 的处理，否则会拼出 "//index.json"。
  const root = String(base || '').replace(/\/+$/, '');
  if (!root) return raw;
  const key = dataFileKey(raw);
  return key ? `${root}/${key}` : raw;
}

export default resolveDataUrl;
